import { createSelector } from 'reselect';

// Config
import { getLoadingLazyComponentSelector } from '@redux/reducers/app/appSelector';
import { getGeoLocationSearchActiveSelector } from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import { getUserSavedCollectionPointsSelector } from '@redux/reducers/user/userSelector';

const clickAndCollectSearchState = createSelector(
  [getUserSavedCollectionPointsSelector, getGeoLocationSearchActiveSelector, getLoadingLazyComponentSelector],
  (collectionPoints, geoLocationSearchActive, loadingLazyComponent) => ({
    collectionPoints,
    geoLocationSearchActive,
    isLoadingLazyComponent: loadingLazyComponent === 'SavedCollectionPointsModal',
  }),
);

export default clickAndCollectSearchState;
